import React from 'react';
import StyledText from 'components/Helpers/StyledText/StyledText';

const Ingressmulti = props => {
  const style = require('./ingressmulti.scss');
  const { children, innerStyle } = props;

  const wrapperClass = style.textwrapper;

  return (
    <p className={wrapperClass}>
      <span className={style.ingress}>

        <StyledText>{children}</StyledText>
        </span>

    </p>
  );
};




export default Ingressmulti;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Page/PageComponents/Ingressmulti/Ingressmulti.js
 **/